var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"hdp-head"},[_c('StepBack',{attrs:{"route":{name: 'HomeView'}},on:{"route":_vm.onRoute}}),_vm._v(" "),_c('div',{staticClass:"hdp-h1"},[_vm._v(_vm._s(_vm.folder.name))])],1),_vm._v(" "),_c('ArticlesList',{attrs:{"articles":_vm.articles},on:{"route":_vm.onRoute}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2aee9cd4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/FolderView.vue
// module id = null
// module chunks = 